import DashboardLayout from "reusableComponents/LayoutContainers/DashboardLayout";
import DashboardNavbar from "reusableComponents/Navbars/DashboardNavbar";
import React, {useEffect, useState} from "react";

import Grid from "@mui/material/Grid";
import SoftBox from "components/SoftBox";
import {Box} from "@mui/material";
import CardComponent from "reusableComponents/Cards/ArticleCard";
import SuiButton from "components/SoftButton";
import {MdRssFeed} from "react-icons/md";
import {IoIosAdd} from "react-icons/io";
import SoftTypography from "components/SoftTypography";
import ReferenceArticleDialog from "./ReferenceArticleDialog";
import {createArticle, getArticles} from "../../axios-client";
import SnackbarNotification from "../../reusableComponents/Snackbar/SnackbarNotification";
import { formatDataToUrlQueryParams } from "utils/generalUtils";

const Articles = () => {

    const [openUploadDialog, setOpenUploadDialog] = useState(false);
    const [isUploading, setIsUploading] = useState(false);
    const [notification, setNotification] = useState({
        show: false,
        snackbarMessage: "",
        severity: "",

    });
    const [filterData, setFilterData] = useState({
        page: 1,
        size: 10,
    });
    const [rows, setRows] = useState([]);
    const [loading, setLoading] = useState(false);
    const [articleCount, setArticleCount] = useState(0);
    const [error, setError] = useState(null);
    useEffect(() => {
        if (filterData) {
            fetchArticles(filterData);
        }
    }, [filterData]);

    const fetchArticles =  () => {
        setLoading(true);
        setError(null);
        const queryParams = formatDataToUrlQueryParams(filterData);
        getArticles(`?${queryParams}`)
        .then((res) => {
            const formattedRows = res.data.articles
            ? res.data.articles.map((article) => ({
                id: article.id,
                authors: article.authors,
                published: article.publication_date,
                title: article.title,
                status: article.status,
                references_count: article.references_count,
                citations_count: article.citations_count,
                createdAt: article.created_at
            }))
            : [];
            setArticleCount(res.data.count);
            setRows(formattedRows);
            setLoading(false);
        })
        .catch((error) => {
          console.error("Error fetching articles:", error);
          setError("Failed to load data. Please try again.");
          setLoading(false);
        });

    };

    const handleOpenDialog = () => {
        setOpenUploadDialog(true);
    };

    const handleCloseDialog = () => {
        setOpenUploadDialog(false);
    };

    
    const handleCreateArticle = (data) => {
        setIsUploading(true);
        createArticle(data)
            .then((response) => {
                setNotification({
                    show: true,
                    snackbarMessage: "Article Created Successfully!",
                    severity: "success",
                });
                setOpenUploadDialog(false);
                setIsUploading(false);
                setFilterData({...filterData, page: 1});
               fetchArticles();
            })
            .catch((error) => {
                setIsUploading(false);
                setNotification({
                    show: true,
                    snackbarMessage: "Error creating article!",
                    severity: "error",
                });
            });
    };

    // Pagination handlers
    const handlePageChange = (newPage) => {
        setFilterData((prev) => ({ ...prev, page: newPage }));
    };

    const handleRowsPerPageChange = (newSize) => {
        setFilterData((prev) => ({ ...prev, size: newSize, page: 1 }));
    };


    return (
        <DashboardLayout>
            <DashboardNavbar/>
            <SoftBox py={2} style={{minHeight: "630px"}}>
                <SoftBox mb={2}>
                    {/* Results Header and Action Button */}
                    <SoftBox
                        display="flex"
                        flexDirection={{xs: 'column', sm: 'row'}}
                        justifyContent="space-between"
                        alignItems={{xs: 'flex-start', sm: 'center'}}
                        gap={1}
                        p={1}
                        style={{paddingTop: "16px", paddingBottom: "16px"}}
                    >
                        <SoftTypography variant="h6" sx={{
                            display: 'flex',
                            alignItems: 'center',
                            flexWrap: 'wrap',
                            fontSize: {xs: '1.1rem', sm: '1.25rem'}
                        }}>
                            <span>results : {articleCount}</span>
                            <MdRssFeed style={{marginLeft: '4px'}}/>
                        </SoftTypography>

                        {/* Error Message */}
                        {error && (
                            <SoftBox mb={2}>
                            <SoftTypography color="error">{error}</SoftTypography>
                            </SoftBox>
                        )}

                        <SuiButton
                            variant="gradient"
                            color="primary"
                            size="small"
                            sx={{
                                width: {xs: '100%', sm: 'auto'},
                                marginTop: {xs: 1, sm: 0}
                            }}
                            onClick={handleOpenDialog}
                        >
                            <IoIosAdd/>
                            Add New Article
                        </SuiButton>
                    </SoftBox>

                    <Box
                        sx={{
                            display: 'flex',
                            flexDirection: {xs: 'column', md: 'row'},
                            gap: 2
                        }}
                    >
                        {/* Results Area */}
                        {loading ? (
                            <SoftBox
                                display="flex"
                                justifyContent="center"
                                alignItems="center"
                                minHeight="200px"
                                width="100%"
                                flexGrow={1}
                            >
                                <SoftTypography>Loading...</SoftTypography>
                            </SoftBox>
                        ) : (
                            <SoftBox
                                sx={{
                                    width: '100%',
                                    flexGrow: 1
                                }}
                            >
                                <Grid container>
                                    <Grid item xs={12}>
                                        <CardComponent
                                            data={rows}
                                            fetchArticles={fetchArticles}
                                            count={articleCount}
                                            size={filterData.size}
                                            page={filterData.page}
                                            loadingData={loading}
                                            handlePageChange={handlePageChange}
                                            handleRowsPerPageChange={handleRowsPerPageChange}
                                        />
                                    </Grid>
                                </Grid>
                            </SoftBox>
                         )} 
                    </Box>
                </SoftBox>
            </SoftBox>


            {/* Upload Article Dialog */}
            {openUploadDialog && (
                <ReferenceArticleDialog
                    open={openUploadDialog}
                    isUploading={isUploading}
                    onClose={handleCloseDialog}
                    handleCreateArticle={handleCreateArticle}
                />
            )}
            
            {/* Snackbar Notification */}
            <SnackbarNotification
                notification={notification}
                setNotification={setNotification}
            />
            
        </DashboardLayout>
    )
}
export default Articles;